import { render } from "./YoutubeVue3.vue?vue&type=template&id=4a3ddb58"
import script from "./YoutubeVue3.vue?vue&type=script&lang=js"
export * from "./YoutubeVue3.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace-temp\\vue\\youtube-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__